import { jsx as _jsx } from "react/jsx-runtime";
import './tippy.css';
import 'tippy.js/dist/tippy.css';
import Tippy from '@tippyjs/react';
const WarningTippy = ({ children, tooltipContent }) => {
    return (_jsx("div", { className: `warning flex justify-end items-center w-full`, children: _jsx(Tippy, { placement: "bottom", animation: "fade", interactive: true, arrow: true, visible: true, offset: [-50, 30], zIndex: 80, content: _jsx("div", { className: "tooltip rounded-8 dark:text-neutral-0 text-paragraph_m font-normal", children: _jsx("div", { children: tooltipContent }) }), children: children }) }));
};
export default WarningTippy;
